/**
 * useAppVersion - Hook to get the app version
 *
 * Returns the current app version from the auto-updates store,
 * which is populated by app.getVersion() from the main process.
 */

import { useAutoUpdatesStore } from '../store/autoUpdatesStore';

/**
 * Returns the current app version string (e.g., "1.0.1")
 */
export function useAppVersion(): string | null {
  return useAutoUpdatesStore((state) => state.state.currentVersion);
}
